import { render, staticRenderFns } from "./TermoAceiteLista.vue?vue&type=template&id=6813c8ee&lang=html&"
import script from "./TermoAceiteLista.vue?vue&type=script&lang=js&"
export * from "./TermoAceiteLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/termo-aceite/TermoAceiteLista.vue
// module id = 1501
// module chunks = 28